/**
 * «Tirar para actualizar» en la bandeja · el respaldo del punto 10 (4-nov-2026).
 *
 * La app instalada en iPhone (modo standalone) no trae el gesto del navegador: sin esto, la única salida ante
 * una lista parada era cerrar la app. El arreglo de fondo es `gestorDeRed.js` (reconectar al volver); esto es
 * lo que la persona puede hacer si aun así duda, y hace lo mismo: reconectar.
 *
 * Sólo cuenta un tirón que EMPIEZA con la página arriba del todo y sigue arriba: tirar hacia abajo a mitad de
 * la lista es desplazarse. Y sólo si es más vertical que horizontal: un barrido en diagonal por la fila de canales
 * (que se desplaza de lado) no es un tirón. La distancia lleva resistencia (el dedo recorre el doble de lo que
 * baja el aviso), con tope, como el gesto nativo. Funciones PURAS, en CommonJS, probadas desde `functions/__tests__`.
 */
const UMBRAL_PX = 70;
const MAX_PX = 110;
const RESISTENCIA = 0.5;

const SIN_TIRON = Object.freeze({ distancia: 0, armado: false });

/**
 * @param {{ inicioY: number|null, y: number, inicioX?: number, x?: number, scrollTop: number }} e
 *   `inicioY` null = el toque no empezó arriba
 * @returns {{ distancia: number, armado: boolean }}  `armado`: soltar ahora actualiza
 */
function progresoDelTiron({ inicioY, y, inicioX = 0, x = 0, scrollTop }) {
  if (inicioY == null || !(scrollTop <= 0)) return SIN_TIRON;
  const dy = y - inicioY;
  // Más de lado que hacia abajo no es un tirón; hacia arriba (dy < 0) tampoco, por la misma comparación.
  if (Math.abs(x - inicioX) > dy) return SIN_TIRON;
  const distancia = Math.min(MAX_PX, dy * RESISTENCIA);
  return { distancia, armado: distancia >= UMBRAL_PX };
}

/**
 * El progreso a guardar: el MISMO objeto si no cambió nada, para que React no vuelva a pintar. Cada `touchmove`
 * de un desplazamiento normal que empezó arriba pasa por aquí (revisión independiente, 🟠2).
 */
function siguienteProgreso(previo, nuevo) {
  return previo.distancia === nuevo.distancia && previo.armado === nuevo.armado ? previo : nuevo;
}

module.exports = { progresoDelTiron, siguienteProgreso, SIN_TIRON, UMBRAL_PX, MAX_PX, RESISTENCIA };
